import React from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import { ReactComponent as Speaker } from 'public/assets/solstice/images/Speakers.svg'

interface Props {
  className?: string
  speakers: SolsticeSpeaker[]
}

const SolsticeSpeaker: React.FC<Props> = ({ className, speakers }) => {
  return (
    <div className={clsx(className)} id="speakers">
      <div className="max-w-xl mx-auto | text-center | mt-24 mb-12">
        <Speaker />
      </div>
      <div className="grid | grid-cols-2 md:grid-cols-3 lg:grid-cols-4 |  gap-8 overflow-auto max-h-[755px]">
        {speakers &&
          speakers.map((item, key) => {
            return (
              <div key={key} className="flex flex-col gap-3 items-center">
                <div className="w-100px h-100px lg:w-[226px] lg:h-[226px] mb-2">
                  <Image
                    src={item?.image.data?.attributes?.url}
                    alt={item?.image.data?.attributes.caption}
                    className="mb-8 rounded-md"
                    height={226}
                    width={226}
                    loading="lazy"
                  />
                </div>
                <div className="text-center">
                  {item.name && (
                    <p className="h6-alt | font-bold | text-yellow-50">
                      {item.name}
                    </p>
                  )}
                  {item.designation && (
                    <p className="my-2 text-small">{item.designation}</p>
                  )}
                  {item.company && (
                    <p className="font-normal text-small">{item.company}</p>
                  )}
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}
export default SolsticeSpeaker
